import { Stack } from '@mui/material'
import { LoadingSkeleton, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'

type InfoValueWithUnitProps = {
    value?: string | number
    unit?: string
    label: string
    isPending?: boolean
    variant?: 'condensed' | 'spacious'
}

export default function InfoValueWithUnit({ variant = 'condensed', ...rest }: InfoValueWithUnitProps) {
    return variant === 'spacious' ? <SpaciousInfoValue {...rest} /> : <CondensedInfoValue {...rest} />
}

function SpaciousInfoValue({ value, unit, label, isPending }: Omit<InfoValueWithUnitProps, 'variant'>) {
    return (
        <Stack direction="row" gap={tokens.SizingSpacing050} justifyContent="space-between">
            <Typography variant="textS" color={tokens.ColorTextBold}>
                {label}
            </Typography>
            <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center">
                {!isPending ? (
                    <Typography variant="textS" color={tokens.ColorTextBold}>
                        {value ?? '-'}
                    </Typography>
                ) : (
                    <LoadingSkeleton width="30px" />
                )}
                {unit && (
                    <Typography variant="textS" color={tokens.ColorTextSubtle}>
                        {unit}
                    </Typography>
                )}
            </Stack>
        </Stack>
    )
}

function CondensedInfoValue({ value, unit, label, isPending }: Omit<InfoValueWithUnitProps, 'variant'>) {
    return (
        <Stack direction="column" gap={tokens.SizingSpacing050}>
            <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center">
                {!isPending ? (
                    <Typography variant="textS" color={tokens.ColorTextBold}>
                        {value ?? '-'}
                    </Typography>
                ) : (
                    <LoadingSkeleton width="30px" />
                )}
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {unit}
                </Typography>
            </Stack>
            <Typography variant="textS" color={tokens.ColorTextSubtle}>
                {label}
            </Typography>
        </Stack>
    )
}
